import { render, staticRenderFns } from "./UcRentalFormProperties.yaml?vue&type=template&id=04e8ba9b&component"
import script from "./UcRentalFormProperties.yaml?vue&type=script&lang=ts&component"
export * from "./UcRentalFormProperties.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports